import { style, styleVariants } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { breakpoints, vars } from "../../styles";

export const dialogContentWrapperStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  border: `1px solid ${vars.colors.outline}`,
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.surface,
  padding: vars.space.m,
  width: "95vw",
  textAlign: "center",
  color: vars.colors.onSurface,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: 600,
    },
  },
});

const baseHeaderStyles = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
});

export const headerStyles = styleVariants({
  standard: [baseHeaderStyles],
  gradient: [
    baseHeaderStyles,
    {
      margin: calc.negate(vars.space.m),
      background: vars.colors.blueLilacGradient,
      borderRadius: `${vars.radii.l} ${vars.radii.l} 0 0`,
      padding: vars.space.s,
    },
  ],
});

export const dialogContent = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});
